import { clientLocale } from "@/shared/localization/language";

export class DateInput {
    private $element: JQuery;
    private $input: JQuery;
    public onChange?: { (newDate: Date | undefined) };

    constructor(label: string, intent?: boolean, cfg?: any) {
        this.$element = $(
            '<div class="dateinput formcontrol' +
                (intent === true ? " intent" : "") +
                '"><label>' +
                label +
                "</label></div>"
        );
        this.$input = $('<input type="text" name="date" autocomplete="off" readonly />').appendTo(this.$element);

        let baseCfg = {
            autoclose: true,
            weekStart: 1,
            format: "dd.mm.yyyy",
            language: clientLocale(),
        };
        baseCfg = { ...baseCfg, ...cfg };

        this.$input.datepicker(baseCfg);
        this.$input.datepicker().on("changeDate", (a) => {
            if (a.date !== undefined && a.date != null) this.$element.addClass("edited");
            else this.$element.removeClass("edited");

            if (this.onChange !== undefined) this.onChange(this.getValue());
        });
    }

    public setLabel(l: string): DateInput {
        this.$element.find("> label").html(l);
        return this;
    }

    public setValue(date?: Date): DateInput {
        this.$input.datepicker("setUTCDate", date === undefined ? null : date);
        return this;
    }

    public getValue(): Date | undefined {
        const d = this.$input.datepicker("getUTCDate");
        if (d == null) return undefined;

        return d;
    }

    public setError(hasError: boolean): DateInput {
        if (hasError) this.$element.addClass("has-error");
        else this.$element.removeClass("has-error");

        return this;
    }

    public appendTo($element: JQuery): DateInput {
        this.$element.appendTo($element);

        return this;
    }
}
